import React from "react";
import "./CSS/StayInspired.css";

const StayInspired = () => {
  return (
    <section className="inspired">
      <div className="inspired-container">
        <h1>Stay Inspired With Us</h1>

        <p>
          Discover styling ideas, new arrivals, and timeless
          <br />
          looks that celebrate your unique elegance every day.
        </p>

        <button className="inspired-btn">
          View All Inspirations
        </button>
      </div>
    </section>
  );
};

export default StayInspired;